import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { getTimesSelector } from '../../times/selectors'
import { setIsNeonatal } from '../store/fluids.actions'
import { FluidsConstants } from '../store/fluids.constants'
import { isValidNemsisDOB } from '../../../utilities/dateTime.util'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { ITimesState } from '../../times/store/times.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* calculateIsNeonatal() {
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const times: ITimesState = yield select(getTimesSelector)

  const { age, ageUnit, dOB } = patientDemographics
  const { dispatchedDate } = times

  let isNeonatal = false

  if (age && ageUnit?.id) {
    const ageValue = parseFloat(age)
    const ageUnitId = ageUnit.id.toString().toLowerCase()

    if (!isNaN(ageValue)) {
      if (ageUnitId === 'y' && ageValue <= 0) {
        isNeonatal = true
      } else if (ageUnitId === 'm' && ageValue <= 1) {
        isNeonatal = true
      } else if (ageUnitId === 'd' && ageValue <= 28) {
        isNeonatal = true
      } else if (ageUnitId === 'h' && ageValue <= 672) {
        isNeonatal = true
      }
    }
  }

  if (!isNeonatal && dOB && isValidNemsisDOB(dOB) && dispatchedDate) {
    try {
      const parseNemsisDate = (dateStr: string): Date | null => {
        const parts = dateStr.split('/')
        if (parts.length === 3) {
          const month = parseInt(parts[0], 10) - 1
          const day = parseInt(parts[1], 10)
          const year = parseInt(parts[2], 10)
          if (parts[2].length === 2) {
            const fullYear = year < 50 ? 2000 + year : 1900 + year
            return new Date(fullYear, month, day)
          }
          return new Date(year, month, day)
        }
        return null
      }

      const dobDate = parseNemsisDate(dOB)
      const dispatchDate = parseNemsisDate(dispatchedDate)

      if (dobDate && dispatchDate && !isNaN(dobDate.getTime()) && !isNaN(dispatchDate.getTime())) {
        const diffTime = dispatchDate.getTime() - dobDate.getTime()
        const diffDays = diffTime / (1000 * 60 * 60 * 24)

        if (diffDays <= 28 && diffDays >= 0) {
          isNeonatal = true
        }
      }
    } catch (e) {
      yield put(throwPcrException(`calculateIsNeonatalSaga() error: ${e}`))
    }
  }

  yield put(setIsNeonatal(isNeonatal))
}

export function* calculateIsNeonatalSaga() {
  yield takeLatest(FluidsConstants.CALCULATE_IS_NEONATAL, performWithMutexHOG, calculateIsNeonatal)
}
